module.exports = __webpack_public_path__ + "fonts/37-Regular.4709164.woff2";